import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./context/AuthContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import AppBootstrap from "./components/AppBootstrap";
import CookieConsentBanner from "./components/legal/CookieConsentBanner";
import { hasSupabaseConfig, supabaseConfigError } from "./services/supabaseClient";

const ConfigErrorScreen = () => (
  <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-10">
    <div className="w-full max-w-2xl rounded-3xl border border-amber-200 bg-white shadow-xl overflow-hidden">
      <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5 text-white">
        <h1 className="text-2xl font-bold">Deployment configuration required</h1>
        <p className="mt-2 text-sm text-amber-50">
          The app loaded, but the hosted environment is missing required production variables.
        </p>
      </div>

      <div className="px-6 py-6 text-slate-700 space-y-4">
        <p>{supabaseConfigError}</p>
        <div className="rounded-2xl bg-slate-50 border border-slate-200 p-4">
          <p className="font-semibold text-slate-900">Add these in Netlify:</p>
          <p className="mt-2 font-mono text-sm text-slate-700">VITE_SUPABASE_URL</p>
          <p className="font-mono text-sm text-slate-700">VITE_SUPABASE_ANON_KEY</p>
          <p className="font-mono text-sm text-slate-700">VITE_APP_URL</p>
        </div>
        <p className="text-sm text-slate-500">
          After saving the variables, trigger a fresh deploy so Vite can bake them into the production bundle.
        </p>
      </div>
    </div>
  </div>
);

function App() {
  if (!hasSupabaseConfig) {
    return <ConfigErrorScreen />;
  }

  return (
    <AuthProvider>
      <AppBootstrap />
      <SubscriptionProvider>
        <Routes />
      </SubscriptionProvider>
      <CookieConsentBanner />
    </AuthProvider>
  );
}

export default App;
